import type { DevelopmentDetailAiAnalysisResponse } from '@/domain/models/development.js';

export function resolveLatestAnalysis(analyses: DevelopmentDetailAiAnalysisResponse[]): DevelopmentDetailAiAnalysisResponse | null {
    return analyses.length > 0 ? analyses.reduce((latest, analysis) => (analysis.attemptNumber > latest.attemptNumber ? analysis : latest)) : null;
}
